
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'app-modal',
})
export default class AppModal extends Vue {
  @Prop({ required: true, type: Boolean })
  readonly show!: boolean;

  @Prop({ required: false, type: String, default: '' })
  readonly header!: string;

  @Prop({ required: false, type: [String, Array], default: '' })
  readonly modalClass!: string | string[];

  @Prop({ required: false, type: [String, Array], default: '' })
  readonly containerClass!: string | string[];

  @Prop({ required: false, type: [String, Array], default: '' })
  readonly bodyClass!: string | string[];

  @Prop({ required: false, type: [String, Array], default: '' })
  readonly helperClass!: string | string[];

  @Prop({ required: false, type: [String, Array], default: '' })
  readonly footerClass!: string | string[];

  @Prop({ required: false, type: Boolean, default: false })
  readonly fullBody!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  readonly noPadding!: boolean;

  @Prop({ required: false, type: String, default: 'md' })
  readonly size!: 'sm' | 'md' | 'lg' | 'xl' | '2xl';

  @Prop({ required: false, type: Boolean, default: false })
  readonly showNavigation!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  readonly canNavigatePrevious!: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  readonly canNavigateNext!: boolean;

  get sizeClass(): string {
    const sizes = {
      'sm': 'sm:max-w-md',
      'md': 'sm:max-w-xl',
      'lg': 'sm:max-w-2xl',
      'xl': 'sm:max-w-4xl',
      '2xl': 'sm:max-w-6xl',
    };
    return sizes[this.size] || sizes.md;
  }

  mounted() {
    document.addEventListener('keydown', this.handleEscKey);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKey);
  }

  handleEscKey(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.show) {
      this.close();
    }
  }

  close() {
    this.$emit('update:show', false);
  }
}
